export default {
  title: 'Dettagli ordine',
};
